"use client";

import PinterestIcon from "@/components/icons/PinterestIcon";
import XingIcon from "@/components/icons/XingIcon";
import { FeatureHighlight } from "@/components/shared/public";
import { Link } from "@/i18n/navigation";
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { useTranslations } from "next-intl";
import { JSX } from "react";
import { floorPlanDetail } from "../../../../public/images/logos";

const SocialIcon = ({ icon, href }: { icon: JSX.Element; href: string }) => {
  return (
    <Link
      className="lg:hover:border-primary lg:hover:text-primary text-ring border-input flex transform cursor-pointer flex-col items-center justify-center rounded-full border-2 p-2 transition-all duration-300"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {icon}
    </Link>
  );
};

const FeatureDescriptions = () => {
  const tC = useTranslations("common");
  const tH = useTranslations("home");

  return (
    // mt-[-350px]
    <div className="gs--page-column w-full">
      <div className="flex flex-col gap-20">
        {/* Feature Informations */}
        <FeatureHighlight
          src={floorPlanDetail}
          alt={"floor plan logo"}
          title={tH("feature.title")}
          text={tH("feature.text")}
          list={[
            tH("feature.listItem"),
            tH("feature.listItem2"),
            tH("feature.listItem3"),
            tH("feature.listItem4"),
          ]}
          link
          linkTitle={tH("feature.linkTitle")}
          href="/grundriss-designs"
        />
        <FeatureHighlight
          src={floorPlanDetail}
          alt={"floor plan logo"}
          title={tH("feature2.title")}
          text={tH("feature2.text")}
          list={[
            tH("feature2.listItem"),
            tH("feature2.listItem2"),
            tH("feature2.listItem3"),
            tH("feature2.listItem4"),
          ]}
        />
      </div>

      <div className="mt-6 flex flex-col justify-start gap-3">
        {/* Social Links */}
        <span className="text-primary text-lg font-medium">
          {tC("followUs")}
        </span>
        <div className="flex flex-wrap items-center justify-start gap-2">
          <SocialIcon
            href="https://www.facebook.com/GrundrissSchmiede/"
            icon={<Facebook size={20} />}
          />
          <SocialIcon
            href="https://www.instagram.com/grundrissschmiede/#"
            icon={<Instagram size={20} />}
          />
          <SocialIcon
            href="https://de.pinterest.com/grundriss_schmiede/"
            icon={<PinterestIcon width={20} height={20} />}
          />
          <SocialIcon
            href="https://www.linkedin.com/company/grundriss-schmiede/"
            icon={<Linkedin size={20} />}
          />
          <SocialIcon
            href="https://www.xing.com/pages/immomates-gmbh"
            icon={<XingIcon width={20} height={20} />}
          />
          <SocialIcon
            href="https://www.youtube.com/channel/UCKZX84eqTlPrAQz5A6KDFWw"
            icon={<Youtube size={20} />}
          />
        </div>
      </div>
    </div>
  );
};

export default FeatureDescriptions;
